module.exports = __webpack_public_path__ + "static/img/IMG_20240209_143227.a368fb8c.jpg";